import React from 'react';
import PropTypes from 'prop-types';

export const Loader = ({ width, height, fill, children, ...props }) => (
  <svg
    data-icon='loader'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 48 48'
    { ...props }
  >
    { children }
    <path
      fill={ fill }
      d='M45 24C46.6569 24 48.0193 22.6517 47.8127 21.0078C47.4282 17.9475 46.4561 14.9804 44.9399 12.2731C42.9334 8.69028 40.0412 5.68222 36.54 3.53664C33.0387 1.39105 29.0455 0.179719 24.9422 0.018503C20.839 -0.142713 16.763 0.751582 13.1042 2.61584C9.44541 4.48011 6.32612 7.25198 4.04473 10.6663C1.76334 14.0807 0.396167 18.0233 0.0739837 22.117C-0.248199 26.2107 0.485385 30.3186 2.20457 34.0478C3.50367 36.8658 5.33272 39.3963 7.58245 41.5061C8.79099 42.6395 10.6826 42.3298 11.6565 40.9894C12.6304 39.6489 12.3109 37.788 11.1506 36.6053C9.70749 35.1342 8.52239 33.4208 7.65342 31.5359C6.36404 28.739 5.81385 25.658 6.05549 22.5877C6.29712 19.5174 7.3225 16.5605 9.03355 13.9997C10.7446 11.439 13.0841 9.36008 15.8282 7.96188C18.5723 6.56369 21.6293 5.89297 24.7067 6.01388C27.7841 6.13479 30.779 7.04329 33.405 8.65248C36.0309 10.2617 38.2001 12.5177 39.7049 15.2048C40.7191 17.0158 41.4087 18.9816 41.7506 21.0138C42.0254 22.6477 43.3431 24 45 24Z'
    />
  </svg>
);

Loader.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
};

Loader.defaultProps = {
  width: 48,
  height: 48,
  fill: 'currentColor',
};
